import { useState, useEffect } from "react";
import { providersService, Provider } from "../services/providers.service";

export const useProviders = (shouldFetch: boolean = true) => {
  const [providers, setProviders] = useState<Provider[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!shouldFetch) return;

    const fetchProviders = async () => {
      setLoading(true);
      try {
        const data = await providersService.getProviders();
        setProviders(data);
      } catch {
        setError("Échec du chargement des fournisseurs");
      } finally {
        setLoading(false);
      }
    };

    fetchProviders();
  }, [shouldFetch]);

  const refetch = async () => {
    setLoading(true);
    try {
      const data = await providersService.getProviders();
      setProviders(data);
    } catch {
      setError("Échec du chargement des fournisseurs");
    } finally {
      setLoading(false);
    }
  };

  return { providers, loading, error, setProviders, refetch };
};
